import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';

export const FeedbackCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: -16px;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0;
  }
`;

export const TextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #757989;
  margin-top: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;

export const NoButton = styled(SecondaryButton)`
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  padding: 0 24px;
  align-self: flex-end;
  min-width: unset !important;
  width: 100%;
  text-transform: uppercase;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 132px !important;
    max-width: 132px;
  }
`;

export const YesButton = styled(NoButton)`
  margin-right: 16px !important;
`;

export const SubmissionStatus = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  color: #000;
  text-transform: uppercase;
  min-height: 40px;
`;

export const IconContainer = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;
